import { AuthProvider } from "@/contexts/AuthContext";
import { UserProfileProvider } from "@/contexts/UserProfileContext";
import { LocaleProvider } from "@/app/i18n/LocaleContext";

export function Providers({ children }: { children: React.ReactNode }) {
    return (
        <LocaleProvider>
            <AuthProvider>
                <UserProfileProvider>
                    {children}
                </UserProfileProvider>
            </AuthProvider>
        </LocaleProvider>
    );
}
